import React from "react";
import Title from "components/Title";
import AddBroadcast from "./AddBroadcast";
const TableHeader = () => {
  return (
    <div
      className="gx-d-flex gx-align-items-center gx-justify-content-between gx-mb-3"
      style={{ flexWrap: "wrap" }}
    >
      <Title title="Broadcast" />

      <AddBroadcast />
    </div>
  );
};

export default TableHeader;
